import { render, staticRenderFns } from "./chatactif.vue?vue&type=template&id=43618808"
import script from "./chatactif.vue?vue&type=script&lang=js"
export * from "./chatactif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports